export const REPORTS_STATUS = {
  approved: 'Approved',
  accepted: 'Accepted',
  expired: 'Expired',
  invited: 'Invited',
  rejected: 'Rejected',
  pending: 'Pending',
};
